export default __webpack_public_path__ + "static/media/m-slogan.76b6baf6.png";